unit uRepEntEmp;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.Buttons;

type
  TFRepEntEmp = class(TForm)
    WebLabel2: TLabel;
    WebSpeedButton11: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebEdit2: TEdit;
    procedure WebSpeedButton11Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  FRepEntEmp: TFRepEntEmp;

implementation

{$R *.dfm}

procedure TFRepEntEmp.WebSpeedButton10Click(Sender: TObject);
begin
FRepEntEmp.Hide;
end;

procedure TFRepEntEmp.WebSpeedButton11Click(Sender: TObject);
Var
Opcion, Empleado, Puesto, Depto, URL: string;
begin
Opcion:='RecordEmpleados';
Empleado:=WebEdit2.Text;

if Empleado = '' then
  begin
    ShowMessage('El campo empleado no se ha capturado!!!');
    Exit;
  end;

URL := 'http://207.244.241.82:9000/PDFReporteQR?Opcion='+Opcion+
  '&Numero='+Empleado;
  asm
  window.open(URL, '_blank');
  end;
end;

procedure TFRepEntEmp.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel2 := TLabel.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebEdit2 := TEdit.Create(Self);

  WebLabel2.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  try
    Name := 'FRepEntEmp';
    Width := 640;
    Height := 480;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 38;
    WebLabel2.Top := 52;
    WebLabel2.Width := 105;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'N'#250'mero de empleado:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 257;
    WebSpeedButton11.Top := 102;
    WebSpeedButton11.Width := 119;
    WebSpeedButton11.Height := 44;
    WebSpeedButton11.Caption := 'Imprimir';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uRepEntEmp.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 257;
    WebSpeedButton10.Top := 52;
    WebSpeedButton10.Width := 119;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uRepEntEmp.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebEdit2.SetParentComponent(Self);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 38;
    WebEdit2.Top := 71;
    WebEdit2.Width := 155;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 6;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
  finally
    WebLabel2.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
  end;
end;

end.